/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { EmittersService } from '../../../core/utils/emitters.service';
import { ToastService, toastTypes } from '../../../shared/toasts/toast/toast.service';
import { ZeyoIaConversationsService } from '../../core/services/zeyo-ia-conversation.service';
import { ZeyoIaService } from '../../core/services/zeyo-ia.service';
import { ChatsIaService } from '../../core/utils/chats-ia.service';
@Component({
	selector: 'app-agent',
	templateUrl: './agent.component.html',
	styleUrls: ['./agent.component.scss']
})
export class AgentComponent implements OnInit {
	@ViewChild('textarea') textarea!: ElementRef;
	@ViewChild('contentResponse') contentResponse!: ElementRef;

	environment = environment;

	loadings = {
		conversation: false
	};

	settings = {
		show: false,
		notification: false,
		segment: 0
	};

	conversationAnalysisId: string;

	constructor(
		_emittersService: EmittersService,
		public chatsIaService: ChatsIaService,
		public authenticationService: AuthenticationService,
		private _zeyoIaService: ZeyoIaService,
		private _zeyoIaConversationsService: ZeyoIaConversationsService,
		private _toastService: ToastService
	) {
		_emittersService.signOut.subscribe(() => (this.settings.show = false));
		_emittersService.notificationIA.subscribe((res) => (this.settings.notification = res));
	}

	ngOnInit(): void {
		setTimeout(() => {
			this._getConversationIds(false);
		}, 1000);
	}

	openChat(): void {
		if (this.loadings.conversation) return;
		if (!this.conversationAnalysisId) {
			this._getConversationIds(true);
		} else {
			this.settings.show = true;
			this.settings.notification = false;
			this.loadings.conversation = false;
		}
	}

	private _getConversationIds(openChat: boolean): void {
		if (!this.authenticationService.currentUser) return;
		this.loadings.conversation = true;
		this._zeyoIaConversationsService.getConversationIds().subscribe({
			next: (res) => {
				for (const element of res.data) {
					if (element.typeConversation === 'analysis') this.conversationAnalysisId = element.id;
				}
				if (!this.conversationAnalysisId) {
					this._createConversation();
					return;
				}
				if (openChat) {
					this.settings.show = true;
					this.settings.notification = false;
				}
				this.loadings.conversation = false;
			},
			error: (err) => {
				this._toastService.initiate({
					title: 'Obtener conversación',
					message: err.description,
					type: toastTypes.error
				});
				this.loadings.conversation = false;
			}
		});
	}

	private _createConversation(): void {
		this.loadings.conversation = true;
		this._zeyoIaService.createConversation('analysis').subscribe({
			next: (res) => {
				this.conversationAnalysisId = res.id;
				this.settings.show = true;
				this.settings.notification = false;
				this.loadings.conversation = false;
			},
			error: (err) => {
				this.loadings.conversation = false;
				this._toastService.initiate({
					title: 'Creacion de conversación',
					message: err.description,
					type: toastTypes.error
				});
			}
		});
	}
}
